import { render, staticRenderFns } from "./CarEdit.vue?vue&type=template&id=936d8d20&scoped=true&"
import script from "./CarEdit.vue?vue&type=script&lang=js&"
export * from "./CarEdit.vue?vue&type=script&lang=js&"
import style0 from "./CarEdit.vue?vue&type=style&index=0&id=936d8d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936d8d20",
  null
  
)

component.options.__file = "CarEdit.vue"
export default component.exports